import n_akacja from './zdjecia/Nektarowy/n_akacja.png';
import n_facelia from './zdjecia/Nektarowy/n_facelia.png';
import n_wielokwiatowy from './zdjecia/Nektarowy/n_wielokwiatowy.png';
import n_rzepakowy from './zdjecia/Nektarowy/n_rzepakowy.png';
import n_lipowy from './zdjecia/Nektarowy/n_lipowy.png';
import n_nawlociowy from './zdjecia/Nektarowy/n_nawlociowy.png';
import n_krem_rzepakowy from './zdjecia/Nektarowy/n_krem_rzepakowy.png';
import n_gryczany from './zdjecia/Nektarowy/n_gryczany.png';
import n_mega_rzepakowy from './zdjecia/Nektarowy/n_mega_rzepakowy.png';
import n_spadziowy from './zdjecia/Nektarowy/n_spadziowy.png';
import n_borowka from './zdjecia/Nektarowy/n_borowka.png';
import n_mieta from './zdjecia/Nektarowy/n_mieta.png';

import malinowyImage from './zdjecia/Smakowy/s_malinowy.jpg';
import s_czarna from './zdjecia/Smakowy/s_czarna.png';
import s_kakao from './zdjecia/Smakowy/s_kakako.png';
import s_cytryna from './zdjecia/Smakowy/s_cytryna.png';
import s_kawa from './zdjecia/Smakowy/s_kawa.png';
import s_rokitnik from './zdjecia/Smakowy/s_rokitnik.png';
import s_pomarancza from './zdjecia/Smakowy/s_pomarancza.png';
import s_orzech from './zdjecia/Smakowy/s_orzech.png';

import i_pylek from './zdjecia/Inne/i_pylek.png';

// Każdy produkt ma `tagline`: jedno krótkie zdanie „wizytówkowe” wyświetlane
// na karcie pod separatorem, oraz `properties`: 4 krótkie właściwości w detalu.
// `options` to warianty opakowania: [{ grams, price }] – większy słoik pierwszy.
const HONEYS = [
  {
    id: 1,
    name: 'Miód Akacjowy',
    tagline: 'Delikatność natury',
    img: n_akacja,
    options: [{ grams: 1000, price: 50 }],
    properties: [
      'Delikatny smak',
      'Łagodzi stres',
      'Wspiera serce',
      'Działa przeciwzapalnie'
    ]
  },
  {
    id: 2,
    name: 'Miód Faceliowy',
    tagline: 'Cicha siła łąk',
    img: n_facelia,
    options: [{ grams: 1000, price: 50 }],
    properties: [
      'Łagodzi alergie',
      'Wspiera drogi oddechowe',
      'Wzmacnia odporność',
      'Wspiera trawienie'
    ]
  },
  {
    id: 3,
    name: 'Miód Gryczany',
    tagline: 'Głębia tradycji',
    img: n_gryczany,
    options: [{ grams: 1000, price: 50 }, { grams: 400, price: 30 }],
    properties: [
      'Wzmacnia organizm',
      'Działa przeciwzapalnie',
      'Wspiera układ krążenia',
      'Działa antybakteryjnie'
    ]
  },
  {
    id: 4,
    name: 'Miód Lipowy',
    tagline: 'Ciepło lipowej łąki',
    img: n_lipowy,
    options: [{ grams: 1000, price: 50 }, { grams: 400, price: 30 }],
    properties: [
      'Pomaga przy przeziębieniu',
      'Działa napotnie',
      'Ułatwia zasypianie',
      'Łagodzi podrażnienia gardła'
    ]
  },
  {
    id: 5,
    name: 'Miód Nawłociowy',
    tagline: 'Złoty blask nad wodą',
    img: n_nawlociowy,
    options: [{ grams: 1000, price: 50 }, { grams: 400, price: 30 }],
    properties: [
      'Wspiera nerki',
      'Działa moczopędnie',
      'Wspomaga drogi moczowe',
      'Działa przeciwzapalnie'
    ]
  },
  {
    id: 6,
    name: 'Miód Rzepakowy',
    tagline: 'Wiosna w słoiku',
    img: n_rzepakowy,
    options: [{ grams: 1000, price: 50 }],
    properties: [
      'Wspiera serce',
      'Źródło łatwo przyswajalnej glukozy',
      'Regeneruje organizm',
      'Naturalne źródło jodu i boru'
    ]
  },
  {
    id: 7,
    name: 'Miód Rzepakowy Kremowany',
    tagline: 'Aksamitna kremowość',
    img: n_krem_rzepakowy,
    options: [{ grams: 1000, price: 50 }],
    properties: [
      'Szybkie źródło energii',
      'Wspiera serce',
      'Wspiera układ krążenia',
      'Naturalne źródło jodu i boru'
    ]
  },
  {
    id: 8,
    name: 'Miód Wielokwiatowy',
    tagline: 'Tajemnica łąk i lasów',
    img: n_wielokwiatowy,
    options: [{ grams: 1000, price: 50 }],
    properties: [
      'Wzmacnia odporność',
      'Dodaje energii',
      'Wspiera organizm',
      'Bogaty w mikroelementy i aminokwasy'
    ]
  },
  {
    id: 9,
    name: 'Miód Spadziowy',
    tagline: 'Leśny sekret iglasty',
    img: n_spadziowy,
    options: [{ grams: 1000, price: 50 }],
    properties: [
      'Wspiera odporność',
      'Działa przeciwbakteryjnie',
      'Wspomaga układ oddechowy',
      'Bogaty w minerały'
    ]
  },
  {
    id: 10,
    name: 'Miód Rzepakowy Z Pyłkiem Pszczelim',
    tagline: 'Energia i witalność',
    img: n_mega_rzepakowy,
    options: [{ grams: 1000, price: 50 }, { grams: 400, price: 30 }],
    properties: [
      'Wspiera odporność',
      'Źródło białka',
      'Zwalcza zmęczenie',
      'Wspiera witalność'
    ]
  },
  {
    id: 11,
    name: 'Miód Z Borówki Amerykańskiej',
    tagline: 'Leśne wspomnienie',
    img: n_borowka,
    options: [{ grams: 1000, price: 50 }, { grams: 400, price: 30 }],
    properties: [
      'Na oczy',
      'Wspomaga odporność',
      'Działa przeciwutleniająco',
      'Wspiera pamięć i koncentrację'
    ]
  },
  {
    id: 12,
    name: 'Miód Z Miętą Długolistną',
    tagline: 'Świeżość na języku',
    img: n_mieta,
    options: [{ grams: 1000, price: 50 }, { grams: 400, price: 30 }],
    properties: [
      'Wspiera trawienie',
      'Odświeża',
      'Łagodzi dolegliwości żołądkowe',
      'Łagodzi nudności'
    ]
  }
];

const SETS = [
  {
    id: 1,
    name: 'Miód Cytryna & Imbir',
    tagline: 'Na zimowe wieczory',
    img: s_cytryna,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Rozgrzewa',
      'Wspiera trawienie',
      'Źródło witaminy C',
      'Pomaga przy przeziębieniu'
    ]
  },
  {
    id: 2,
    name: 'Miód Do Kawy Z przyprawami',
    tagline: 'Poranny rytuał',
    img: s_kawa,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Rozgrzewa',
      'Wspiera trawienie',
      'Bogaty w antyoksydanty',
      'Wspiera poziom glukozy'
    ]
  },
  {
    id: 3,
    name: 'Miód Pomarańcza & Goździki',
    tagline: 'Rozgrzewający wieczór',
    img: s_pomarancza,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Rozgrzewa',
      'Wspiera odporność',
      'Źródło witaminy C',
      'Działa antyoksydacyjnie'
    ]
  },
  {
    id: 4,
    name: 'Miód Z Czarną Porzeczką',
    tagline: 'Jagodowy charakter',
    img: s_czarna,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Bogactwo witaminy C',
      'Wspiera odporność',
      'Działa antyoksydacyjnie',
      'Naturalny smak i kolor'
    ]
  },
  {
    id: 5,
    name: 'Miód Z Kakao',
    tagline: 'Czekoladowa przyjemność',
    img: s_kakao,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Pobudza bez kofeiny',
      'Poprawia nastrój',
      'Źródło magnezu',
      'Słodycz bez dodatku cukru'
    ]
  },
  {
    id: 6,
    name: 'Miód Z Malinami',
    tagline: 'Szept letniego ogrodu',
    img: malinowyImage,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Wspiera odporność',
      'Działa przeciwgorączkowo',
      'Źródło witaminy C',
      'Działa antyoksydacyjnie'
    ]
  },
  {
    id: 7,
    name: 'Miód Z Rokitnikiem',
    tagline: 'Bomba witaminowa',
    img: s_rokitnik,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Wzmacnia odporność',
      'Źródło witaminy C',
      'Wspiera skórę i błony śluzowe',
      'Działa antyoksydacyjnie'
    ]
  },
  {
    id: 8,
    name: 'Miód Z Orzechami Laskowymi i Kakao',
    tagline: 'Słodycz natury',
    img: s_orzech,
    options: [{ grams: 400, price: 30 }],
    properties: [
      'Źródło witaminy E',
      'Źródło białka',
      'Daje energię na dłużej',
      'Źródło magnezu'
    ]
  }
];

const POLLENS = [
  {
    id: 1,
    name: 'Pyłek Pszczeli',
    tagline: 'Naturalna bomba witaminowa',
    img: i_pylek,
    options: [{ grams: 200, price: 15 }],
    properties: [
      'Źródło białka (25%)',
      'Bogaty w minerały',
      'Wspiera odporność',
      'Regeneruje organizm'
    ]
  }
];

export const CATALOG = [
  { id: 'nektarowe', title: 'Miody Nektarowe', products: HONEYS },
  { id: 'smakowe', title: 'Miody Smakowe', products: SETS },
  { id: 'inne', title: 'Inne Produkty Pszczele', products: POLLENS }
];

// Klasa CSS nadająca kolorystykę danej karcie (tytuł i separator).
export const getProductClass = (name) => 'prod-' + name
  .toLowerCase()
  .replace(/[óòôõö]/g, 'o')
  .replace(/[ąàáâãä]/g, 'a')
  .replace(/[ęèéêë]/g, 'e')
  .replace(/[ćç]/g, 'c')
  .replace(/[ł]/g, 'l')
  .replace(/[ń]/g, 'n')
  .replace(/[ś]/g, 's')
  .replace(/[źż]/g, 'z')
  .replace(/[^a-z0-9\s-]/g, '')
  .trim()
  .replace(/\s+/g, '-');

// Unikalny klucz produktu w adresie URL: #produkt/nektarowe-3
export const getProductKey = (sectionId, product) => `${sectionId}-${product.id}`;

export const findProductByKey = (key) => {
  for (const section of CATALOG) {
    const product = section.products.find((item) => getProductKey(section.id, item) === key);
    if (product) {
      return { section, product };
    }
  }
  return null;
};